import Empty from 'antd/es/empty';

export default Empty;
